import { useTranslations } from 'next-intl'
import styles from './ProcessingDCBPayment.module.css'
import { useLogout } from '@/apiUtilities/mutations/useLogout'
import { useRouter } from '@/i18n/navigation'
import { CircularProgress } from '@mui/material'
import { useSelf } from '@/apiUtilities/queries/useSelf'
import { useEffect, useRef, useState } from 'react'
import { toast } from 'react-toastify'
import Notification from '@/components/Notification/Notification'

interface DTPaymentModalProps extends React.HTMLAttributes<HTMLDivElement> {
  onClose: () => void
}

export default function ProcessingDCBPaymentModal ({ onClose}: DTPaymentModalProps) {
  const t = useTranslations('Modals.ProcessingDCB')
  const router = useRouter()
  const [pollCount, setPollCount] = useState(0)
  const [shouldPoll, setShouldPoll] = useState(true)
  const pollTimeout = useRef<NodeJS.Timeout | null>(null)
  const self = useSelf({ enabled: shouldPoll })
  const params = new URLSearchParams(window.location.search)
  useEffect(() => {
    if (self.isSuccess && self.data && self.data.purchase) {
      setShouldPoll(false)
      const successUrl = params.get('registration') === 'true' ? '/add-profile?registration=true' : '/home'
      router.push(successUrl)
      return
    }

    if (shouldPoll && pollCount < 5) {
      pollTimeout.current = setTimeout(() => {
        setPollCount(c => c + 1)
        self.refetch()
      }, 3000)
    }

    if (pollCount >= 5 && shouldPoll) {
      setShouldPoll(false)
      toast.error(<Notification text={t('error')} />)
      onClose()
    }

    return () => {
      if (pollTimeout.current) clearTimeout(pollTimeout.current)
    }
  }, [pollCount, self.data, shouldPoll])

  return (
    <div className={styles.main}>
      <CircularProgress color={"inherit"} size="2.5rem" />
      <h3 className={`title3 ${styles.title}`}>{t('title')}</h3>
      <p className={`bodyTextLarge ${styles.description}`}>{t('description')}</p>
    </div>
  )
}